import React from "react";
import { PlanType } from "../../components/enums/plan-type";
import HealthPlan from "../../components/health-plan";

const Medical = ({ pageStep }) => {
  return (
    <HealthPlan pageStep={pageStep} defaultPlanId="WAIVED" waivedOption="5" defaultPlanDescription="Medical" planType={PlanType.Medical} />
  );
};

export default Medical;
